// Maps registry / bridge-pushed icon names to lucide-react components.
// Falls back to rendering the string verbatim (covers any name not in the
// map). Sub-apps and the registry use kebab-case names (e.g. "bar-chart-3").
import {
  Activity,
  BarChart3,
  Banknote,
  BookOpen,
  Bookmark,
  Box,
  Calendar,
  CalendarDays,
  Check,
  ChevronRight,
  ClipboardList,
  Clock,
  Compass,
  File as FileIcon,
  FileText,
  Film,
  FlaskConical,
  Folder,
  GitPullRequest,
  Handshake,
  Home,
  Keyboard,
  Layers,
  LayoutGrid,
  LayoutPanelLeft,
  Lightbulb,
  LineChart,
  Link as LinkIcon,
  ListChecks,
  Lock,
  MessageSquare,
  Mic,
  Monitor,
  Moon,
  Palette,
  PanelLeft,
  Pencil,
  Plus,
  Ruler,
  SatelliteDish,
  Scroll,
  Send,
  Settings,
  Sparkles,
  Sun,
  TrendingDown,
  TrendingUp,
  Wallet,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  banknote: Banknote,
  "bar-chart-3": BarChart3,
  bookmark: Bookmark,
  "book-open": BookOpen,
  box: Box,
  calendar: Calendar,
  "calendar-days": CalendarDays,
  check: Check,
  "chevron-right": ChevronRight,
  "clipboard-list": ClipboardList,
  clock: Clock,
  compass: Compass,
  file: FileIcon,
  "file-text": FileText,
  film: Film,
  "flask-conical": FlaskConical,
  folder: Folder,
  "git-pull-request": GitPullRequest,
  handshake: Handshake,
  home: Home,
  keyboard: Keyboard,
  layers: Layers,
  "layout-grid": LayoutGrid,
  "layout-panel-left": LayoutPanelLeft,
  lightbulb: Lightbulb,
  "line-chart": LineChart,
  link: LinkIcon,
  "list-checks": ListChecks,
  lock: Lock,
  "message-square": MessageSquare,
  mic: Mic,
  monitor: Monitor,
  moon: Moon,
  palette: Palette,
  "panel-left": PanelLeft,
  pencil: Pencil,
  plus: Plus,
  ruler: Ruler,
  "satellite-dish": SatelliteDish,
  scroll: Scroll,
  send: Send,
  settings: Settings,
  sparkles: Sparkles,
  sun: Sun,
  "trending-down": TrendingDown,
  "trending-up": TrendingUp,
  wallet: Wallet,
};

export function getLucideIcon(name: string | undefined): LucideIcon | null {
  if (!name) return null;
  return ICONS[name] ?? null;
}

export interface AppIconResolverProps {
  name: string | undefined;
  size?: number;
  className?: string;
}

export function AppIconResolver({ name, size = 16, className }: AppIconResolverProps) {
  if (!name) return null;
  const Lucide = ICONS[name] ?? Box;   // neutral glyph for any unmapped name — never the raw string
  return <Lucide size={size} className={className} aria-hidden />;
}
